module.exports = __webpack_public_path__ + "img/16l006-09.a5ea9a74.jpg";